module.exports = __webpack_public_path__ + "static/media/s_head.d5977ecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/active20/s_head.png
// module id = 812
// module chunks = 0